import { Box, Typography } from '@mui/material'
import ScrollDownIndicator from '../common/ScrollDownIndicator'
import {
  MOBILE_MQ,
  mobileBodyTextSx,
  mobilePaddingX,
  mobileSectionPy,
  mobileSectionTitleSx,
} from '../../theme/mobileLayout'

export default function AboutHeroSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: mobilePaddingX,
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: { xs: 4, md: 6 },
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          maxWidth: 1040,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '25px',
          textAlign: 'center',
          [MOBILE_MQ]: { gap: '20px' },
        }}
      >
        <Typography
          component="h1"
          sx={{
            ...mobileSectionTitleSx,
            fontSize: { ...mobileSectionTitleSx.fontSize, lg: 80 },
            width: '100%',
          }}
        >
          Empowering Communities Through Compassion
        </Typography>
        <Typography
          sx={{
            ...mobileBodyTextSx,
            width: '100%',
          }}
        >
          Building a Better Tomorrow Together
        </Typography>
      </Box>

      <ScrollDownIndicator
        sx={{ mt: { xs: 6, md: 10, lg: '346px' } }}
        textSx={{ fontSize: { xs: 18, md: 24 } }}
      />
    </Box>
  )
}
